import React from "react";

import { useTranslation } from "react-i18next";

import r1 from '../../img/AboutUs/r1.webp'
import r2 from '../../img/AboutUs/r2.webp'

function Raw () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex flex-col xl:flex-row justify-between">
                    <div className="xl:max-w-[460px]">
                        <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] leading-[1.4]">{t('about.30')}</p>
                        <p className="mt-[30px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">{t('about.31')}</p>
                        <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">{t('about.32')}</p>
                    </div>
                    <div className="mt-[35px] xl:mt-0">
                        <div className="bg-[#272727] flex gap-[15px] items-center py-[15px] xl:py-[20px] px-[15px] xl:px-[30px]">
                            <img src={r1} alt="" className="xl:w-[97px] xl:h-[97px] w-[60px] h-[60px]"/>
                            <div>
                                <p className="font-[600] open-sans text-[14px] xl:text-[16px] text-[#F26522]">{t('about.33')}</p>
                                <p className="text-[#F6F6F6] text-[14px] xl:text-[16px] open-sans mt-[15px] xl:w-[429px]">{t('about.34')}</p>
                            </div>
                        </div>
                        <div className="bg-[#272727] flex gap-[15px] items-center py-[15px] xl:py-[20px] px-[15px] xl:px-[30px] mt-[15px] xl:mt-[30px]">
                            <img src={r2} alt="" className="xl:w-[97px] xl:h-[97px] w-[60px] h-[60px]"/>
                            <div>
                                <p className="font-[600] open-sans text-[14px] xl:text-[16px] text-[#F26522]">{t('about.35')}</p>
                                <p className="text-[#F6F6F6] text-[14px] xl:text-[16px] open-sans mt-[15px] xl:w-[429px]">{t('about.36')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Raw;